import React from "react"
import { Container, Row, Col } from "react-bootstrap"
// import PropertyBtn from "../PropertyBtn/PropertyBtn"

import SearchResultMarketingBanner from "@components/MarkettingBanner/SearchResultMarketingBanner"
import SearchResultsPagination from "../SearchResultsPagination/SearchResultsPagination"
import PropertyCard from "../PropertyCard/PropertyCard"

import "./SalesCard.scss"

const SalesCard = ({
  algoliaData,
  pathName,
  marketingBanner,
  noProperty,
  searchState,
}) => {
  const propertyList =
    algoliaData?.hits?.length > 0 ? algoliaData?.hits : noProperty?.nodes

  // console.log("algoliaData", algoliaData)

  return (
    <section className="sales-section">
      <Container>
        <Row>
          <Col>
            <div className="sales-wrapper">
              {propertyList?.length > 0
                ? propertyList?.map((item, index) => {
                    return (
                      <React.Fragment key={item.objectID}>
                        <PropertyCard item={item} />

                        <SearchResultMarketingBanner
                          module={{
                            marketing_banner: marketingBanner,
                          }}
                          propertyList={propertyList}
                          algoliaData={algoliaData}
                          propertyIndex={index}
                        />

                        {/* {algoliaData?.hits?.length > 8 &&
                        (index + 1) % 4 === 0 ? (
                          <SearchResultMarketingBanner
                            module={{
                              marketing_banner: marketingBanner,
                            }}
                            propertyList={propertyList}
                            algoliaData={algoliaData}
                            propertyIndex={index}
                          />
                        ) : (
                          ""
                        )} */}
                      </React.Fragment>
                    )
                  })
                : ""}
            </div>
          </Col>
        </Row>

        {algoliaData?.total > algoliaData?.hitsPerPage ? (
          <SearchResultsPagination
            page_url_data={searchState}
            locationPath={pathName}
            total={algoliaData?.total}
            currentPageNumber={algoliaData?.currentPageNumber}
            hitsPerPage={algoliaData?.hitsPerPage}
            nbPages={algoliaData?.numberOfPages}
          />
        ) : (
          ""
        )}
      </Container>
    </section>
  )
}
export default SalesCard
